import { UntypedFormGroup } from '@angular/forms';
import { ValueUOMFG } from './elevators.model';
import { isNotNullOrEmptyString } from '../../../../shared/utils/functions';

export class ElevatorsValidatos {
  static notEmptyUOM(valueUomFG: UntypedFormGroup): { [key: string]: boolean } {
    const valueUOM: ValueUOMFG = valueUomFG.value;
    return isNotNullOrEmptyString(valueUOM.val) && !isNotNullOrEmptyString(valueUOM.uom) ? { emptyUOM: true } : null;
  }
}
